import React from 'react'
import { Tooltip as TooltipAnt } from 'antd'
import { TooltipProps } from 'antd/lib/tooltip'

import { useT } from 'src/core/hooks/use-translation'

function Tooltip({ title, children, ...props }: TooltipProps) {
  const { t } = useT()
  return (
    <TooltipAnt title={t(title)} {...props}>
      {children}
    </TooltipAnt>
  )
}

export default Tooltip
